import { formatInTimeZone } from "date-fns-tz";
export function date(value: string | Date | null, includeTime = false) {
  return value
    ? formatInTimeZone(
        new Date(value),
        "America/New_York",
        includeTime ? "MMM d, yyyy h:mm a zzz" : "MMM d, yyyy",
      )
    : "Not yet";
}
export function safeUrl(value?: string | null) {
  if (!value) return null;
  try {
    const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
    return ["http:", "https:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}
/**
 * Elapsed time between two instants, in the coarsest units that stay readable.
 * An open interval measures to now, so a running step reports what it has
 * already spent rather than nothing at all.
 */
export function duration(from: string | Date | null, to: string | Date | null = null) {
  if (!from) return null;
  const ms = new Date(to ?? Date.now()).getTime() - new Date(from).getTime();
  if (!Number.isFinite(ms) || ms < 0) return null;
  const seconds = Math.round(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}
